import { render } from "./showVideo.vue?vue&type=template&id=3395c0fc&scoped=true&ts=true"
import script from "./showVideo.vue?vue&type=script&lang=ts"
export * from "./showVideo.vue?vue&type=script&lang=ts"

import "./showVideo.vue?vue&type=style&index=0&id=3395c0fc&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3395c0fc"]])

export default __exports__